export default [
  {
    title: 'For Applicants',
    icon: 'BookIcon',
    children: [
      {
        title: 'Guide',
        route: 'guide',
      },
      {
        title: 'List of required documents',
        route: 'required-docs',
      },
      {
        title: 'Find organization by direction',
        route: 'find-org-by-direction',
      },
    ],
  },
  {
    title: 'Applied doc count by organization',
    route: 'applied-doc-count-by-org',
    icon: 'BarChart2Icon',
  },
  {
    title: 'Regulation',
    route: 'regulation',
    icon: 'FileIcon',
  },
  {
    title: 'Frequently asked qestions (FAQ)',
    route: 'asked-questions',
    icon: 'InfoIcon',
  },
  {
    title: 'Contacts',
    route: 'contacts',
    icon: 'MailIcon',
  },
  {
    title: 'Imtihon dasturlari va taqdimotlar',
    route: 'exam-program-presentations-front',
    icon: 'FileTextIcon',
  },
  {
    title: 'Scientific topics',
    icon: 'BookIcon',
    children: [
      {
        title: 'Approved scientific topics',
        route: 'approved-scientific-topics',
      },
      {
        title: 'Recommended scientific topics',
        route: 'topics',
      },
    ],
  },
  // {
  //   title: 'Call center',
  //   route: 'call-center',
  //   icon: 'PhoneIcon',
  // },
  // {
  //   title: 'Open data',
  //   icon: 'AwardIcon',
  //   children: [
  //     {
  //       title: 'Admission results',
  //       route: 'admission-results',
  //     },
  //     {
  //       title: 'Efficiency (Region)',
  //       route: 'efficiency',
  //     },
  //     {
  //       title: 'Efficiency (Ministries)',
  //       route: 'efficiency-ministries',
  //     },
  //     {
  //       title: 'Efficiency (HEI and RI)',
  //       route: 'efficiency-hei',
  //     },
  //     {
  //       title: 'Efficiency (Specialties)',
  //       route: 'efficiency-specialties',
  //     },
  //     {
  //       title: 'Dissertation topics',
  //       route: 'dissertation-topics',
  //     },
  //     {
  //       title: 'Exam results',
  //       route: 'exam-results',
  //     },
  //   ],
  // },
]
